export const DEFAULT_DURATION = 5000;
export const DEFAULT_MIN_WIDTH = 200;
export const DEFAULT_MAX_WIDTH = 350;
export const NOTIFICATION_TRANSITION_ENTER =
  'all 350ms cubic-bezier(.21, 1.02, .73, 1)';
export const NOTIFICATION_TRANSITION_EXIT =
  'all 200ms cubic-bezier(.06,.71,.55,1)';
export const DEFAULT_POSITION = 'bottom-right';
